import { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import {
  CREATE_BOOK_CONTENT,
  UPDATE_BOOK_CONTENT,
} from "../../../Schema/BookContent";

const useBookContentForm = ({
  mutationDelete,
  editData,
  profileHook,
  handleClose,
  resetForm,
  setRefetch,
}) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createBookContent] = useMutation(CREATE_BOOK_CONTENT, {
    onCompleted: ({ createBookContent }) => {
      setLoading(false);

      if (createBookContent?.isSuccess === true) {
        setAlert(true, "success", createBookContent?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createBookContent?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateBookContent] = useMutation(UPDATE_BOOK_CONTENT, {
    onCompleted: ({ updateBookContent }) => {
      // console.log("updateBookContent::", updateBookContent);
      setLoading(false);
      if (updateBookContent?.isSuccess === true) {
        setAlert(true, "success", updateBookContent?.message);
        handleClose();
        resetForm();
        setRefetch();
        if (profileHook && editData?.file) {
          let splitSrc = editData?.file?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", updateBookContent?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateBookContent, createBookContent, loading, setLoading };
};

export default useBookContentForm;
